import { Component, OnInit } from '@angular/core';
import { PosHttpService } from '../../../services/pos.http.service';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, TABLE_ACTION_TYPE, TableAction, FnBreadcrumbModule} from 'foundation';
import { EOProduct } from '../../../modal/entity.modal';
import { Subject } from 'rxjs';
import { EOProductModalComponent } from './eoproduct-modal/eoproduct-modal.component';
import { Router } from '@angular/router';


@Component({
	selector: 'app-product',
	templateUrl: './product.component.html',
	styleUrl: './product.component.scss'
})
export class ProductComponent implements OnInit {
	constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService, private toaster: FnToasterService, private fnBreadcrumbModule: FnBreadcrumbModule, private router: Router) {

	}
	ngOnInit(): void {
		this.loadData();
	}

	uiMap = {
		isDataLoaded: false,
	};
	showData = false;

	config: FnTableConfig = {
		uniqueKey: 'primaryKey',
		defaultSortKey: 'primaryKey',
		tableAction: new Subject<TableAction>(),
	};

	rowMetaArray: FnTableMetaData[] = [
		{
			key: 'primaryKey',
			description: 'Primary Key',
			isHidden: true,
			isSortable: true,
			type: 'number',
		},
		{
			key: 'name',
			description: 'Name',
			type: 'string',
			isSortable: true,
		},
		{
			key: 'defaultEscEmailID',
			description: 'Default Esc Email ID',
			type: 'string',
			isSortable: true,
		},

	];

	productArray: EOProduct[] = [];


	loadData() {
		this.posHttpSvcs.authGet('v1/ui/loadEoProductData', 'loadEoProductData').subscribe((resp: any) => {
			if (resp.isError) {
				this.toastr.error('Invalid loadEoProductData ⚠️');
				return;
			}
			this.productArray = resp.data;
			this.showData = false;
			this.refreshTableData();
			this.uiMap.isDataLoaded = true;
		});
	}
	updateRowAction(event: EOProduct) {
		const productModal = this.fnModalSvcs.openCustomModal(EOProductModalComponent, {
			data: {
				eoProduct: event
			},
			hasBackdrop: true,
			width: '500px',
		})
		productModal.afterClosed().subscribe((objectHash) => {
			if(objectHash != undefined){
			this.addUpdateEOProduct(objectHash);
			}
		});
	}
	deleteRowAction(event: EOProduct) {
		const dialogRef = this.fnModalSvcs.openConfirmModal({
			isConformationMdl: true,
			content: 'Are you sure you want to delete EOPRoduct ?',
			type: 'danger',
		});
		dialogRef.afterClosed().subscribe(doAction => {
			if (doAction) {
				this.posHttpSvcs.authDeleteWithBody('v1/ui/deleteProduct', event.primaryKey, event).subscribe(resp => {
					this.loadData();
				})
			}
		});

	}

	openActionMdl() {
		const productModal = this.fnModalSvcs.openCustomModal(EOProductModalComponent, {
			data: {
			},
			hasBackdrop: true,
			width: '500px',
		})
		productModal.afterClosed().subscribe((objectHash) => {
			if(objectHash != undefined){
				this.addUpdateEOProduct(objectHash);
			}
			
		});
	}

	addUpdateEOProduct(objectHash: any) {
		this.posHttpSvcs.authPut('v1/ui/saveProduct', 'saveProduct', objectHash).subscribe(resp => {
			if (resp.isError) {
				this.toastr.error(' EOProduct is not added ⚠️');
				return;
			} else {
				this.toastr.success("added successfully");
				this.loadData();
			}
		})

	}

	refreshTableData() {
		if (this.config.tableAction.closed) {
			this.config.tableAction = new Subject<TableAction>();
		}
		this.config.tableAction.next({
			data: this.productArray,
			action: TABLE_ACTION_TYPE.REFRESH,
		});
	}
}
